<template>
	<!-- Start 底部 -->
	<div class="footer-area">
		<div class="container">
			<div class="row gx-6">
				<div class="col-lg-3 col-md-6">
					<div class="footer-wiget">
						<div class="footer-wiget-log">
							<a href=""><img src="@/assets/image/footer-logo.png" alt=""></a>
						</div>
						<div class="footer-wiget-text">
							<h4>让科技</h4>
						</div>
						<div class="footer-shape-title">
							<h3>便捷生活</h3>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6">
					<div class="footer-wiget">
						<div class="footer-wiget-menu">
							<ul>
								<li @click="navClick('/product')"><a href="javascript:;">产品中心</a></li>
								<li @click="navClick('/solution')"><a href="javascript:;">解决方案</a></li>
								<li @click="navClick('/case')"><a href="javascript:;">经典案例</a></li>
							</ul>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6">
					<div class="footer-wiget">
						<div class="footer-wiget-menu">
							<ul>
								<li @click="navClick('/news')"><a href="javascript:;">新闻资讯</a></li>
								<li @click="navClick('/about')"><a href="javascript:;">关于泽火</a></li>
							</ul>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 pr-0">
					<div class="foter-box">
						<div class="footer-wiget-icon">
							<img src="@/assets/image/zehuo_code.jpg"/>
						</div>
						<div class="footer-widget-contct-menu">
							<ul>
								<li><a href="#">电话：0592-6217119</a></li>
								<li class="line"><a href="#">邮箱：market@zehuotime.com</a></li>
								<li><a href="#">地址：厦门集美软件园三期F02栋1012室</a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row align-items-center mt-50">
				<div class="col-lg-12 col-md-12">
					<div class="copyright-text">
						<p>Copyright &copy; 2022 泽火时代科技（厦门）有限公司. All Rights Reserved 闽ICP备2022009441号</p>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- End 底部 -->
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			navClick(url) {
				if (url == this.$route.path) return
				this.$router.push(url)
			}
		}
	}
</script>

<style>
</style>